var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pt-10"},[_c('data-table',{attrs:{"headers":_vm.$options.carriersHeaderConfig,"items":_vm.carriers,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.name)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }